import React, { useContext, useEffect } from 'react'
import { QuestionContext } from '../../../../Context'
import { BarItemCon, ProgressBarStyle } from './styles'

export const ProgressBarCon: React.FC = () => {
  const { questions, questionIndex, goToQuestion } = useContext(QuestionContext)!

  useEffect(() => {}, [questionIndex])

  return (
    <ProgressBarStyle total={questions.length}>
      {questions.length > 0 &&
        questions.map((q, idx) => (
          <BarItemCon
            key={q.questionId}
            filled={idx <= questionIndex}
            total={questions.length}
            onClick={() => goToQuestion(idx)}
          />
        ))}
    </ProgressBarStyle>
  )
}
